import React from "react";
import { Link } from "react-router-dom";
import { Church, GitBranch, MapPin, ShieldCheck } from "lucide-react";

// Lot 631 — page d'une église mère : section « Nos annexes » (assemblées vérifiées rattachées).
export const ChurchAnnexes = ({ annexes, t }) => {
  if (!annexes?.length) return null;
  return (
    <div className="yalola-card p-4" data-testid="church-annexes" data-count={annexes.length}>
      <div className="flex items-center gap-2 mb-1">
        <GitBranch size={16} style={{ color: "#1E40AF" }} />
        <h2 className="font-semibold" style={{ fontFamily: "Outfit" }}>{t("church.annexes_title", "Nos annexes")} · {annexes.length}</h2>
      </div>
      <p className="text-xs mb-3" style={{ color: "var(--yalola-text-muted)" }}>{t("church.annexes_hint", "Assemblées rattachées à cette église mère.")}</p>
      <div className="grid sm:grid-cols-2 gap-2">
        {annexes.map((a) => (
          <Link key={a.id} to={`/churches/${a.handle || a.id}`} className="flex items-center gap-3 rounded-xl border p-2.5 hover:bg-[rgba(0,0,0,0.03)] transition-colors" style={{ borderColor: "var(--yalola-border)" }} data-testid={`church-annex-${a.id}`}>
            <div className="h-10 w-10 rounded-full overflow-hidden grid place-items-center shrink-0" style={{ background: "#EFF6FF" }}>
              {a.logo_url ? <img src={a.logo_url} alt="" className="h-full w-full object-cover" /> : <Church size={18} style={{ color: "#1E40AF" }} />}
            </div>
            <div className="min-w-0">
              <div className="text-sm font-semibold truncate flex items-center gap-1">{a.name}{a.verified && <ShieldCheck size={13} style={{ color: "var(--yalola-accent)" }} />}</div>
              <div className="text-xs flex items-center gap-1 truncate" style={{ color: "var(--yalola-text-muted)" }}><MapPin size={11} /> {a.city}, {a.country}</div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

// Lot 631 — profil d'un pasteur : « Responsable de N églises » + liens vers les pages.
export const LedChurches = ({ churches, t }) => {
  if (!churches?.length) return null;
  const n = churches.length;
  return (
    <div className="py-2.5 border-b last:border-0" style={{ borderColor: "var(--yalola-border)" }} data-testid="profile-led-churches" data-count={n}>
      <div className="flex items-center gap-3">
        <Church size={18} style={{ color: "var(--yalola-text-muted)" }} />
        <span className="text-sm font-semibold">{n === 1 ? t("profile.leads_churches_one", "Responsable de 1 église") : t("profile.leads_churches_n", "Responsable de {n} églises").replace("{n}", n)}</span>
      </div>
      <div className="flex flex-wrap gap-1.5 mt-2 pl-[30px]">
        {churches.map((c) => (
          <Link key={c.id} to={`/churches/${c.handle || c.id}`} className="chip text-xs" style={{ background: "var(--yalola-primary-soft, #fff7ed)", color: "var(--yalola-primary)" }} data-testid={`profile-led-church-${c.id}`}>
            {c.name}{c.parent_church_id ? ` · ${t("church.annex_short", "annexe")}` : ""}
          </Link>
        ))}
      </div>
    </div>
  );
};
